import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'
import App from './App.jsx'
import { t } from './utils/i18n';

// Persist debug flag early (before any router redirects can drop the querystring)
try {
  const params = new URLSearchParams(window.location.search);
  if (params.get('debug') === '1') {
    sessionStorage.setItem('tt_debug', '1');
  } else if (params.get('debug') === '0') {
    sessionStorage.removeItem('tt_debug');
  }
} catch (_) {}

// Sentry 초기화 (DSN은 환경변수로)
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Replay 비활성화 (updateFrom 버그)
    ],
    tracesSampleRate: 0.1, // 10% 성능 추적
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div className="page text-center">{t('ui.errorOccurred')}</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
